import React, { useContext } from "react";
import Log from "../components/Log";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { UidContext } from "../components/AppContext";
import Categorie from "../components/Categorie";

const Home = () => {
  const uid = useContext(UidContext);

  return (
    <div>
      <Header />
      <Categorie />
      <Footer />
    </div>
  );
};

export default Home;
